import { isAxiosError } from 'axios';

import type { InstallationMonorepo } from './installation-monorepo.types';

import http from './installation-monorepo.http';

export default {
  create: async ({ partnerId, payload }: InstallationMonorepo.CreateParams) => {
    const res = await http.post<InstallationMonorepo.CreateResponse>(
      `/api/v1/partners/${partnerId}/installation-bypass`,
      payload,
    );

    return res.data.data;
  },

  getByPartnerId: async (
    { partnerId, step_to_bypass }: InstallationMonorepo.GetByPartnerIdParams,
  ): Promise<InstallationMonorepo.BypassRecord | null> => {
    try {
      const res = await http.get<InstallationMonorepo.GetByPartnerIdResponse>(
        `/api/v1/partners/${partnerId}/installation-bypass`,
        { params: step_to_bypass ? { step_to_bypass } : undefined },
      );

      return res.data.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return null;
      }

      throw error;
    }
  },

  remove: async ({ partnerId }: InstallationMonorepo.RemoveParams) => {
    const res = await http.delete<InstallationMonorepo.RemoveResponse>(
      `/api/v1/partners/${partnerId}/installation-bypass`,
    );

    return res.data;
  },

  resetCommissioning: async ({
    projectId,
    reason,
  }: InstallationMonorepo.ResetCommissioningParams) => {
    const res = await http.post<InstallationMonorepo.ResetCommissioningResponse>(
      `/api/v1/installations/project/${projectId}/monitoring/reset`,
      { reset_reason: reason },
    );

    return res.data.data;
  },
};
